// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_70mm_60mm_1_label_layout__35-pq"};